import React, { ReactNode } from "react";
import styled from "styled-components";
import Legend from "@charty/legend";
import { Item } from "@charty/legend/item/model";
import Tooltip from "@charty/tooltip/histogram";
import { GlossyTheme } from "@glossy/theme/types";
import { AbstractDate, Range } from "@linkfluence/models/date";
import { Locale } from "@linkfluence/models/locale";
import { Serie } from "../models";
import { useLegendSeries, useTotal } from "./data";

type ChartTooltip = {
  count: number;
  label: string;
  color: string;
  date: AbstractDate;
  total?: number;
};
interface IProps {
  series: Serie[];
  range: Range;
  locale: Locale;
  onClickLegend?: (uid: Item["id"]) => void;
  tooltip?: (serie: Item, total: number) => ReactNode;
  total?: number;
  chartTooltip?: (props: ChartTooltip[]) => ReactNode;
  theme: GlossyTheme;
  setHovered: (id: string) => void;
  disableAnimation?: boolean;
  displayVolumes?: boolean;
}

const StyledLegend = styled(Legend)`
  margin-bottom: 12px;
`;

const DoubleTimeChartLegend = React.memo(
  ({
    series,
    range,
    locale,
    tooltip,
    total,
    onClickLegend,
    theme,
    setHovered,
    disableAnimation,
    displayVolumes,
  }: IProps) => {
    const legendSeries = useLegendSeries(series, locale, theme);
    const _total = useTotal(total, legendSeries);

    return (
      <StyledLegend
        setHovered={setHovered}
        items={legendSeries}
        align="left"
        locale={locale}
        onClickSerie={onClickLegend}
        tooltip={
          tooltip
            ? (serie) => tooltip(serie, _total)
            : (serie) => (
                <Tooltip
                  count={serie.count}
                  label={serie.label}
                  color={serie.color}
                  locale={locale}
                  range={range}
                  total={_total}
                />
              )
        }
        disableAnimation={disableAnimation}
        displayVolumes={displayVolumes}
      />
    );
  }
);

export default DoubleTimeChartLegend;
